import { reloadDatatable } from "../common/datatables";

const props = {
    manualFinderProductManagementDatatableMarker: '.marker-manual-finder-product-management',
    manualFinderProductManagementDatatable: '#dt-manual-finder-product-management',
    searchterm_selector: '#SearchField'
}; 

export function initDtAdminManualFinderProductManagement() {

    if ($(props.manualFinderProductManagementDatatableMarker).length) {
        dtAdminManualFinderProductManagement(initManualFinderProductManagementDatatableEvents);
        setupManualFinderProductManagementSearchEvents();
    }
}

const setupManualFinderProductManagementSearchEvents = () => {

    //PURPOSE: initialises events associated with the text search field
    $(props.searchterm_selector).off("keypress").on('keypress', (e) => {
        if (e.which === 13) {
            e.preventDefault();

            reloadManualFinderProductManagementDatatable();
        }
    });

    //PURPOSE: initialises search button click event
    $('.mdc-text-field__icon').off("click").on('click', (e) => {
        reloadManualFinderProductManagementDatatable();
    });
};


const reloadManualFinderProductManagementDatatable = () => {
    //PURPOSE: reloads user management datatable data on demand
    //pass callback through that binds click events to rows; this will be run once the table is fully reloaded and rendered
    reloadDatatable(props.manualFinderProductManagementDatatable, initManualFinderProductManagementDatatableEvents, true);
};

export function initManualFinderProductManagementDatatableEvents() {

    //PURPOSE: sets up the full row click select for the user search dt
    $(props.manualFinderProductManagementDatatable).off('click').on('click', 'tbody td', function (event) {

        if ($(this).hasClass('dataTables_empty')) {

            //if no results are returned for a datatable it adds the message as a row.
            //as such this event binder still acts when theres no row to click through on.
            //the check above neutralises this issue
            return;
        }

        var itemId = $(event.currentTarget).parent('tr').data('id');

        window.location.href = '/administration/manualfindermanagement/editproduct/' + itemId;
    });
}


function dtAdminManualFinderProductManagement(onloadCallback) {

    if ($(props.manualFinderProductManagementDatatable).length === 0) return false;

    $(props.manualFinderProductManagementDatatable).DataTable({
        iDisplayLength: 50,
        initComplete: onloadCallback,
        paging: true,
        info: true,
        ordering: true,
        filter: false,
        lengthChange: false,
        serverSide: true,
        deferRender: true,
        ajax: {
            url: '/administration/manualfindermanagement/manualfinderproductmanagementsearch',
            data: function (d) {
                d.searchterm = $(props.searchterm_selector).val();
            },
            dataSrc: function (data) {

                if (data.responseType === 'SUCCESS')
                    return data.data;
                else
                    responseError(data);
            },
            error: function (jqXHR, textStatus, errorThrown) {
                console.log(textStatus);
            },
            type: 'POST'
        },

        columns: [
            { data: 'parentCategoryPath', name: 'Parent Category Path' },
            { data: 'code', name: 'Code' },
            { data: 'title', name: 'Title' }
        ],
        order: [[2, "desc"]],

        createdRow: function (row, data, dataIndex) {
            $(row).attr('data-id', data.id);
        }

    });
}
